<style lang="less" scoped>
    .activewrap{
        margin: 88px 0;
        background: #FBF6F6;
        .imgwrap{
            width: 100%;
            height:420px;
            justify-content: center;
            align-items: center;
            display: flex;
            overflow: hidden;
            img{
                display:block;
                max-width: 100%;
                max-height: 100%;
            }
        }
        
        ul{
            
            background: #fff;
            li{
                padding-left:30px;
                border-bottom: solid 1px #EFEFEF;
                p{
                    padding: 24px 0px;
                    font-size: 28px;
                }
                .info{
                    margin-left: 24px;
                    color: #5B5C66;
                    width: 552px;
                }
                .title{
                    width: 120px;
                    color: #333440;
                }
            }
        }
        .formwrap{
            background: url("../images/baoming.png") no-repeat;
            background-size: 100% 100%;
            height: 368px;
            .content{
                width: 566px;
                padding-top: 120px;
                margin-left: 40px;
                dl{
                    margin-top: 14px;
                    height: 62px;
                    line-height: 62px;
                    dt{
                        float: left;
                        
                        color: #BA9E70;
                        width: 80px;
                        text-align: left;
                    }
                    dd{
                        margin-left: 26px;
                        float: left;
                        input.wt460{
                            height: 60px;
                            width: 460px;
                        }
                        input.wt260{
                            height: 60px;
                            width: 260px;
                        }
                        .checkbtn{
                            width: 184px;
                            height: 60px;
                            line-height: 60px;
                            font-size: 24px;
                            color: #BA9E70;
                            background: #FFFFFF;
                            border-radius: 2px;
                            text-align: center;
                            margin-left: 12px;
                        }
                    }
                }
            }
        }
        .btnsubmit{
            height: 80px;
            background-image: linear-gradient(-90deg, #EF4B4B 4%, #F7643C 100%);
            line-height: 80px;
            color: #fff;
            text-align: center;
            font-size: 30px;
        }
        .btnsubmitflex{
            height: 80px;
            background-image: linear-gradient(-90deg, #EF4B4B 4%, #F7643C 100%);
            line-height: 80px;
            color: #fff;
            text-align: center;
            font-size: 30px;
            position:fixed;
            display: block;
            width: 100%;
            bottom: 0;

        }
        .popupwrap{
            width: 480px;
            height: 484px;
            background: url("../images/popupbg.png") no-repeat;
            background-size: 100% 100%;
            p{
                text-align: center;
                color:  #A4A4A4;
                margin-top: 10px;
            }
            .title{
                padding-top: 254px;
                font-size: 36px;
                color: #5B5C66;
                text-align: center;
            }
        }
        .mint-popup{
            background:none;
        }
    }
</style>
<style lang="less">
.activewrap{
    .htmlDiv{
        img,video,table{
            max-width: 100%;
        }
    }
}
</style>

<template>
  <div class="activewrap">
      <v-downTip :popShow="popShow" ></v-downTip>
      <v-shareHeader :content="shareSwiper"></v-shareHeader>
      <v-shareFooter :content="shareSwiper"></v-shareFooter>
      <mt-popup v-model="popupVisible">
        <div class="popupwrap">
            <p class="title">报名成功</p>
            <p>感谢您的报名</p>
            <p>请于当日准时参加本次活动</p>
        </div>
      </mt-popup>
      <div class="imgwrap">
          <img :src="content.activityBanner" alt="">
      </div>
      <ul @click="toStore">
          <li class="clearfix">
              <p class="fl title">活动名称</p>
              <p class="fl info" v-text="content.activityName"></p>
          </li>
          <li class="clearfix">
              <p class="fl title">活动时间</p>
              <p class="fl info" v-text="content.activityTime"></p>
          </li>
          <li class="clearfix">
              <p class="fl title">活动地点</p>
              <p class="fl info" v-text="content.activityAddress"></p>
          </li>
          <li class="clearfix">
              <p class="fl title">发起单位</p>
              <p class="fl info" v-text="content.companyName"></p>
          </li>
          <li class="clearfix">
              <p class="fl title">活动概要</p>
              <p class="fl info htmlDiv" v-html="content.activityIntroduce"></p>
          </li>
      </ul>
      <div class="formwrap" v-if="content.isSignUp!='1'" @click="toStore">
          <div class="content">
            <dl class="clearfix">
                <dt>姓名</dt>
                <dd>
                    <input type="text" class="wt460" v-model="formdata.signUpName">
                </dd>
            </dl>
            <dl class="clearfix">
                <dt>手机号</dt>
                <dd>
                    <input type="num" class="wt460" v-model="formdata.mobile">
                </dd>
            </dl>
            <dl class="clearfix">
                <dt>验证码</dt>
                <dd class="clearfix">
                    <input type="text" class="wt260 fl" v-model="formdata.identifyingCode" maxlength="4">
                    <p class="fl checkbtn" @click="toStore" v-if="getFlg">获取验证码</p>
                    <p class="fl checkbtn" v-else>{{'重新获取('+yzmNumber+')'}}</p>
                </dd>
            </dl>
          </div>

      </div>
      
      <p v-if="content.isSignUp=='1'" class="btnsubmitflex">已报名</p>
      <p v-else class="btnsubmit" @click="toStore">提交报名</p>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import global from "../js/global.js"
import weixin from "../js/weixinall.js"
export default {
  data () {
    return {
        popupVisible:false,
        content:{},
        yzmNumber:60,//验证码倒计时
        getFlg:true,
        authCodeId:"",//验证码ID
        formdata:{"signUpName":"","mobile":"","identifyingCode":""},
        token:"",
        popShow:false,
        shareSwiper:'',
    }
  },
  created(){
      this.init();
  },
  mounted(){
    weixin.shareInfo(1,this.$route.query.contentId,this.$route.query.accountId)
    weixin.shareTitle(1,this.$route.query.contentId,(data)=>{
      this.shareSwiper = data;
    });
  },
  methods:{
    toStore(){
      this.popShow = global.toStore(this.shareSwiper)
    },
    closeTip(){
      this.popShow = false;
    },
    init(){//operateType 2陵园
      // this.$http.get("/content/industry/activity/activityDetail?activityId="+"5aa63829f5f2ab000171ed9b"+"&accountId=32") 
        this.$http.get("/content/industry/activity/activityDetail?activityId="+this.$route.query.contentId+"&accountId="+this.$route.query.accountId)
        .then((response) => {
            this.content=response.respData;                
        });
    },
    getYzm(){
        
        if(this.formdata.mobile=="") {
            this.$toast('请输入您的手机号');
            return;
        } else if(this.formdata.mobile.length != "11"){
            this.$toast('请输入11位手机号');
            return;	
        }else if(!(/^1[3|4|5|7|8]\d{9}$/.test(this.formdata.mobile))){
            this.$toast('请输入正确的手机号');
            return;
        }
        // this.$http.get("/account/activity/get?mobile="+this.formdata.mobile,{headers:{"Authorization":"bearer 56c2945cdc7a60c99dda6564005a1c06"}})
        this.$http.get("/account/activity/get?mobile="+this.formdata.mobile,{headers:{"Authorization":"bearer "+this.token+""}})
        .then((response) => {
            this.getFlg = false;
            var timer = setInterval(()=>{
                this.yzmNumber--
                if(this.yzmNumber <= 0){
                    this.getFlg = true;
                    this.yzmNumber = 60;
                    clearInterval(timer);
                }
            },1000);            
            this.authCodeId = response.respData;
        });
    },
    submitFn(){
        if(this.formdata.signUpName==""){
            this.$toast("姓名不能为空");
            return;
        }
        else if(this.formdata.mobile=="") {
            this.$toast('请输入您的手机号');
            return;
        } else if(this.formdata.mobile.length != "11"){
            this.$toast('请输入11位手机号');
            return;	
        }else if(!(/^1[3|4|5|7|8]\d{9}$/.test(this.formdata.mobile))){
            this.$toast('请输入正确的手机号');
            return;
        }
        else if(this.formdata.identifyingCode==""){
            this.$toast("验证码不能为空");
            return;
        }
        Indicator.open();
        let data = Object.assign({"activityId":this.$route.query.contentId,"accountId":this.$route.query.accountId,"authCodeId":this.authCodeId},this.formdata)
        // this.$http.post("/content/industry/activity/activitySignUp"+global.buildParams(data),"",{headers:{"Authorization":"bearer 56c2945cdc7a60c99dda6564005a1c06"}})
        this.$http.post("/content/industry/activity/activitySignUp"+global.buildParams(data),"",{headers:{"Authorization":"bearer "+this.token+""}})
        .then((response) => {
            Indicator.close();
            if(response.respCode == 0){
                this.$toast(response.respMsg);
            }else{
                this.content.isSignUp=1                
                this.popupVisible=true;
                setTimeout(()=>{
                    this.popupVisible=false;
                },3000)
            }           
        });
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/share/shareactivitiesInfo.vue